import {translate} from "../../utils";

export default class Item extends PIXI.Container {

    get url() {
        return this._data.url;
    }

    constructor(data) {
        super();

        this._bg = new PIXI.Sprite(P3.assets.texture("template_decision"));
        this._bg.anchor.set(0.5, 0);
        this._bg.position.set(0, -140);
        this.addChild(this._bg);

        this._image = new PIXI.Sprite(P3.assets.texture(data.image));
        this._image.anchor.set(0.5, 0);
        this._image.position.set(0, -140);
        this.addChild(this._image);

        this._data = data;
    }
}